import React, { useEffect, useState } from "react";

// react query client
import { useQueryClient } from "react-query";

// components
import { BootstrapModal } from "../BootstrapModal/Modal";
import Button from "../Button/Button";
import { InputField1 } from "../InputField1/InputField1";
import Typogaphy from "../Typography/Typography";

// react icons
import { CgClose } from "react-icons/cg";

// styled components
import { Wrapper } from "../../theme/GlobalStyle";
import { useAddNewUser, useUpdateUser } from "../../hooks/useAccounting";
import { SimpleSelect1 } from "../SimpleSelect/SimpleSelect1";

const initialState = [
  {
    id: "1",
    label: "بی حساب",
    value: "بی حساب",
  },
  {
    id: "2",
    label: "بدهکار",
    value: "بدهکار",
  },
  {
    id: "3",
    label: "بستانکار",
    value: "بستانکار",
  },
];

const AddNewUserDialog = ({
  isToggle,
  toggleHideModal,
  PageNumber,
  updatedUser,
}) => {
  const [form, setForm] = useState({
    FirstName: "",
    LastName: "",
    Phone: "",
    ExistenceOfFirstPeriod: "",
    AmountOfFirstPeriod: "",
  });

  //   query client
  const queryClient = useQueryClient();

  // handle change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
  };
  // handle submit

  const { mutateAsync: addNewUser, isLoading: loadingAddUser } =
    useAddNewUser();

  const { mutateAsync: updateUser } = useUpdateUser();

  const handleSubmit = async () => {
    if (updatedUser?.FirstName) {
      await updateUser(form);
    } else {
      await addNewUser(form);
    }
    queryClient.invalidateQueries("list-user", PageNumber);
    toggleHideModal();
  };

  useEffect(() => {
    if (updatedUser) {
      setForm({
        FirstName: updatedUser.FirstName,
        LastName: updatedUser.LastName,
        ExistenceOfFirstPeriod: updatedUser?.ExistenceOfFirstPeriod,
        AmountOfFirstPeriod: updatedUser.AmountOfFirstPeriod,
        IdPerson: updatedUser.IdUser,
      });
    }
  }, [updatedUser]);

  return (
    <BootstrapModal
      modaltitle="درج شخص جدید"
      handleClose={toggleHideModal}
      show={isToggle}
      size="md"
      closebutton={
        <Button
          style={{ width: "40px", border: "none" }}
          onclick={toggleHideModal}
        >
          <CgClose />
        </Button>
      }
    >
      <InputField1
        name="FirstName"
        type="text"
        label="نام"
        onChange={handleChange}
        value={form.FirstName}
        required
      />
      <InputField1
        name="LastName"
        type="text"
        label="نام خانوادگی"
        onChange={handleChange}
        value={form.LastName}
        required
      />
      {updatedUser?.FirstName ? null : (
        <InputField1
          name="Phone"
          type="text"
          label="شماره تماس"
          onChange={handleChange}
          value={form.Phone}
          required
        />
      )}

      <SimpleSelect1
        res={initialState}
        label="موجودی اول دوره"
        onChange={(e) => setForm({ ...form, ExistenceOfFirstPeriod: e.value })}
        placeholder={updatedUser.ExistenceOfFirstPeriod}
      />
      <InputField1
        type="number"
        label="باقی مانده اول دوره"
        onChange={(e) =>
          setForm({
            ...form,
            AmountOfFirstPeriod:
              form.ExistenceOfFirstPeriod === "بی حساب" ? 0 : e.target.value,
          })
        }
        value={form.AmountOfFirstPeriod}
        required
      />
      <Wrapper>
        <Button
          bgColor="#28A745"
          spaceLeft=".5rem"
          color="#fff"
          size="14px"
          onclick={handleSubmit}
        >
          {loadingAddUser ? (
            <Typogaphy size="14px" primary="#fff">
              Loading...
            </Typogaphy>
          ) : (
            "تایید"
          )}
        </Button>
        <Button
          bgColor="#DC3545"
          color="#fff"
          size="14px"
          onclick={toggleHideModal}
        >
          انصراف
        </Button>
      </Wrapper>
    </BootstrapModal>
  );
};

export default AddNewUserDialog;
